/* eslint-disable react/no-unknown-property */
// Scene.js
import { Canvas, useThree } from '@react-three/fiber';
import { useGLTF, OrbitControls } from '@react-three/drei';
import PropTypes from 'prop-types';
import { Perf } from 'r3f-perf';
import { useEffect, useRef, useState } from 'react';
import * as THREE from 'three'
import gsap from "gsap"

// On créé un composant qui va contenir les éléments de notre scène
// Obligatoire afin de récupérer les informations de logs de la caméra
// Pourra être supprimé lorsque tout sera posé
function Elements({ onCameraReady, views, index }) {
    const { scene } = useGLTF('./assets/3d/CDS_Radio_3_b.glb');
    const { camera } = useThree();
    const [ isCameraInitialized, setIsCameraInitialized ] = useState(false);

    // Appelle la fonction passée dès que la caméra est dispo
    if (onCameraReady) onCameraReady(camera);

    // Mise en place de l'écouteurt du changement d'index afin d'effectuer l'animation de transition vers la
    // nouvelle vue
    useEffect(() => {
        /**
         * moveCameraPosition - Fonction permettant de déplacer la caméra
         * @param {number} px - Position en x
         * @param {number} py - Position en y
         * @param {number} pz - Position en z
         * @param {string} easingfunction - Fonction d'easing
         */
        function moveCameraPosition(position, rotation, orbit, easingfunction = "power2.inOut") {
            gsap.to(camera.position, {
                x: position.x,
                y: position.y,
                z: position.z,
                duration: 2,
                ease: easingfunction,
                onUpdate: () => camera.lookAt(new THREE.Vector3(orbit.x, orbit.y, orbit.z))
            });

            gsap.to(camera.rotation, {
                x: rotation.x,
                y: rotation.y,
                z: rotation.z,
                duration: 2,
                ease: easingfunction
            });
        }

        /**
         * handleSwitchView - Fonction permettant de gérer le changement de vue
         */
        function handleSwitchView() {
            // On déplace la caméra
            moveCameraPosition(views[index].position, views[index].rotation, views[index].orbit)
        }

        // On ne souhaite pas avoir d'animation à l'initialisation de la caméra lors de
        // l'ouverture de la page
        if(!isCameraInitialized) {
            setIsCameraInitialized(true);
            return;
        }

        // Sinon à chaque changement de vue on effectue l'animation
        handleSwitchView()
    }, [index]);

    return (
        <>
            <ambientLight intensity={3} />
            {/* <directionalLight position={[0, 100, 100]} intensity={5} /> */}
            <primitive object={scene} />
        </>
    )
}

Elements.propTypes = {
    onCameraReady: PropTypes.func.isRequired,
    views: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
};

function Scene({ views, index, isPerfVisible }) {
    const [cameraInfos, setCameraInfos] = useState(null);
    // const [cameraPosition, setCameraPosition] = useState({});
    // const [cameraRotation, setCameraRotation] = useState({});
    // const [cameraOrbit, setCameraOrbit] = useState({});
    const controlsRef = useRef();

    // useEffect(() => {
    //     // Appelé qu'une seule fois à l'initialisation de la page
    //     setCameraPosition({
    //         x: views[index].position.x,
    //         y: views[index].position.y,
    //         z: views[index].position.z
    //     });
    //     setCameraRotation({
    //         x: views[index].rotation.x,
    //         y: views[index].rotation.y,
    //         z: views[index].rotation.z
    //     });
    //     setCameraOrbit({
    //         x: views[index].orbit.x,
    //         y: views[index].orbit.y,
    //         z: views[index].orbit.z
    //     })
    // }, []);

    // On définit la fonction qui va nous permettre de log les données de la caméra
    // function logCameraInfo(camera, ref) {
    //     const pos = camera.position;
    //     const rotation = camera.rotation;
    //     const target = ref.current?.target;
    //     console.log(`position: { x: ${pos.x.toFixed(2)}, y: ${pos.y.toFixed(2)}, z: ${pos.z.toFixed(2)} }`);
    //     console.log(`rotation: { x: ${rotation.x.toFixed(2)}, y: ${rotation.y.toFixed(2)}, z: ${rotation.z.toFixed(2)} }`);
    //     console.log(`orbit: { x: ${target.x.toFixed(2)}, y: ${target.y.toFixed(2)}, z: ${target.z.toFixed(2)} }`);
    //     console.log({camera});
    //     console.log('-----------');
    // }

    return (
        <div className="carousel-scene" style={{position: 'relative'}}>
            <Canvas
                camera={{
                    position: [-3.11, 1.47, -0.07],
                    rotation: [-1.75, -1.34, -1.75],
                    fov: 35
                }}
                aria-label="Image en 3D de la radio avec points d’intérêt">
                {isPerfVisible && <Perf style={{ top: '1em', right: '1em' }} />}
                <Elements onCameraReady={setCameraInfos} views={views} index={index} />
                <OrbitControls ref={controlsRef} target={[-0.05, 0.75, 0.06]} minDistance={1.3} maxDistance={6} />
            </Canvas>
            {/* <button
                style={{position: 'absolute', top: 0, left: 0, transform: 'scale(0.5)'}}
                onClick={() => logCameraInfo(cameraInfos, controlsRef)}
            >Logger</button> */}
        </div>
    );
}

Scene.propTypes = {
    views: PropTypes.array.isRequired,
    index: PropTypes.number.isRequired,
    isPerfVisible: PropTypes.bool.isRequired
};

export default Scene;
